<div class="main-container ">
  <h1>Record Video</h1>
  
  <div class="step-progress-container">
    <div class="step-progress">
      <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1">1</div>
      <div class="step-line" [class.active]="currentStep > 1"></div>
      <div class="step" [class.active]="currentStep === 2" [class.completed]="currentStep > 2">2</div>
      <div class="step-line" [class.active]="currentStep > 2"></div>
      <div class="step" [class.active]="currentStep === 3" [class.completed]="currentStep > 3">3</div>
      <div class="step-line" [class.active]="currentStep > 3"></div>
      <div class="step" [class.active]="currentStep === 4" [class.completed]="currentStep > 4">4</div>
    </div>
  </div>

  
  <div class="video-recorder-container" *ngIf="!showThankYouMessage">
   
    <div class="record-container">
      <video #previewVideo id="preview" width="640" height="480" muted autoplay></video>
    </div>

   
    <video #recordedVideo id="recorded" width="640" height="480" controls autoplay muted>
       <source [src]="currentVideoUrl" type="video/mp4" />
    </video>

    
    <div class="btns">
      <button class="media" (click)="toggleVideo()"><i class="bi media-icons " [ngClass]="isVideoOn ? 'bi-camera-video-fill' : 'bi-camera-video-off'" ></i></button>

      <button class="media" (click)="toggleMic()"><i class="bi media-icons" [ngClass]="isMicOn ? 'bi-mic' : 'bi-mic-mute'" ></i></button>
      
      
    
      <button [disabled]="isDisabled" class="record-button" (click)="startRecording()" >
        {{ countdown > 0 ?countdown +':'+'0': "Start Recording "}}
      </button>
      
     
      <button class="cancel-button" (click)="cancelRecording()" [style.visibility]="isRecording ? 'visible' : 'hidden'">
        Cancel
      </button>
    </div>
  </div>

  <!-- Instructions Section - Now positioned under the video recorder -->
  <div class="instructions-container" *ngIf="!showThankYouMessage && instructions.length > 0">
    <h3>Instructions </h3>
    <div class="instructions-content">
      <ol class="instructions-list">
        <li *ngFor="let instruction of instructions" class="instruction-item">
          {{ instruction }}
        </li>
      </ol>
    </div>
  </div>

 
  <div *ngIf="showThankYouMessage" class="feedback-container">
    <h2>Thank You For Recording!</h2>
    <form [formGroup]="feedbackForm" class="feedback-form" (ngSubmit)="submitFeedback()">
      <label for="feedback" class="feedback-label">Write your feedback about the interview:</label>
      <textarea 
        id="feedback" 
        class="feedback-textarea" 
        placeholder="Please share your thoughts about the interview experience..."
        rows="6"
        formControlName="feedback">
      </textarea>
      <div class="error-message" *ngIf="feedbackForm.get('feedback')?.invalid && feedbackForm.get('feedback')?.touched">
        <span *ngIf="feedbackForm.get('feedback')?.errors?.['minlength']">Feedback must be at least 10 characters.</span>
      </div>
      <button type="submit" class="submit-feedback-btn">
        Submit Feedback
      </button>
    </form>
  </div>
</div>
